import React, { useState, useEffect, useContext } from 'react';

import { Card, Table, Container, Alert, ProgressBar, Badge } from 'react-bootstrap';

import axios from 'axios';
import FileDownload from 'js-file-download';
import moment from 'moment';
import _ from 'lodash';
import { MessageModal } from '../components';
import UserContext from '../contexts/UserContext';
import Utils from './../Utils';
import { utils } from 'sortablejs';

const UserScormList = (props) => {

  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({ offset: 0, limit: 10, sortby: "id", sortdir: "desc" });
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [message, setMessage] = useState(false);
  const udata = Utils.getUserData();
  const { loadDraft, deleteDraft, saveDraft, checkPkgValidity, thirdPUserData } = useContext(UserContext);
  const [showDraft, setShowDraft] = useState(false);
  const [pkgInfo, setPkgInfo] = useState({});

  useEffect(() => {
    if (udata.draft == 'edit') setShowDraft(false);
  }, []);

  const getDraft = () => {
    const isAllowed = (validity) => {

      if (!validity.validity) Utils.confirmBuyNow(validity.message);
      else {
        loadDraft();
        setShowDraft(false);
      }
    }

    checkPkgValidity(isAllowed);

  }
  const delDraft = () => {
    if (window.confirm("Are you sure to delete this draft permanently?")) {
      deleteDraft((success, msg) => {
        if (success) {
          alert(msg);
          udata.draft = false;
          setShowDraft(false);
          setMessage(false);
        }
      });
    }
  }

  const fetchScorms = () => {

    setLoading('Fetching your saved SVASUs.. please wait..');

    axios.post(Utils.apiUrl('Scorm/list'), { ...filter }, Utils.apiHeaders()).then(res => {
      setLoading(false);
      setData(res.data.data);
      setPkgInfo(res.data.pkg);
      setTotal(res.data.total);
    }).catch(err => {
      window.alert(JSON.stringify(err));
    });
  }

  useEffect(fetchScorms, [filter]);

  const checkUserDraft = () => {
    axios.get(Utils.apiUrl('Draft/checkUserDraft'), Utils.apiHeaders())
      .then(res => {
        if (res.data.success) {
          setShowDraft(res.data.data);
        }
      }
      )
      .catch(err => console.log("Draft check error : ", err));
  }
  const checkDraft = (op) => {
    if (udata.draft == 'edit') {
      alert(`You are already editing draft.\n${op}ing course will save it as draft again.`);
      saveDraft('list', (success, msg) => {
        setMessage([success ? 'info' : 'error', msg]);
      });
    }
  }

  useEffect(checkUserDraft, []);
  const onEdit = (rec) => (e) => {
    checkDraft('Edit');

    const isAllowed = (validity) => {

      if (!validity.validity) Utils.confirmBuyNow(validity.message);
      else {
        let udata = Utils.getUserData();
        udata[`stepData${udata.id}`] = { step: 1 };
        localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData', JSON.stringify(udata));
        window.location.href = `${process.env.PUBLIC_URL}/builder/${rec.id}/${rec.is_web}`;
      }
    }

    window.setTimeout(function () { checkPkgValidity(isAllowed); }, 100);
  }

  const handleAdd = (e) => {
    checkDraft('Add');
    const isAllowed = (validity) => {

      if (!validity.validity) Utils.confirmBuyNow(validity.message);
      else {
        let udata = Utils.getUserData();
        udata[`stepData${udata.id}`] = { step: 1 };
        localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData', JSON.stringify(udata));
        window.location.href = `${process.env.PUBLIC_URL}/builder`;
      }
    }

    window.setTimeout(function () { checkPkgValidity(isAllowed); }, 100);
  }
  const handleBuy = (e) => {
    window.location.href = process.env.REACT_APP_URL + '#buy-now';
  }

  const onClone = (rid, isweb) => (e) => {
    checkDraft('Clon');
    const isAllowed = (validity) => {

      if (!validity.validity) Utils.confirmBuyNow(validity.message);
      else {

        Utils.setCourseType('clone');
        setLoading('Cloning your SVASU.. please wait..');
        var api = '';
        if (isweb === '1') {
          api = Utils.apiUrl('Web/clone');
        } else {
          api = Utils.apiUrl('Scorm/clone');
        }
        axios.post(api, { id: rid }, Utils.apiHeaders()).then(res => {
          if (res.data.success) {
            let udata = Utils.getUserData();
            udata[`stepData${udata.id}`] = { step: 1 };
            udata[`stepData${udata.id}`]['scorm_id'] = res.data.newid;
            localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData', JSON.stringify(udata));
            window.location.href = process.env.PUBLIC_URL + '/builder/' + res.data.newid + '/' + isweb;
          } else {
            window.alert(res.data.error);
          }
        }).catch(err => {
          window.alert(JSON.stringify(err));
        });
      }
    }

    window.setTimeout(function () { checkPkgValidity(isAllowed); }, 100);
  }

  const onDownload = (rid, folder, isweb) => (e) => {
    var headers = { ...Utils.apiHeaders(), "responseType": "blob" };
    setMessage(['info', ['Please wait, We are processing your file...']]);
    setMessage(['info', ['Please wait, We are processing your file.']]);
    var api = '';
    if (isweb === '1') {
      api = Utils.apiUrl('Web/download?id=' + rid);
    } else {
      api = Utils.apiUrl('Scorm/download?id=' + rid);
    }
    axios.get(api, headers).then((res) => {
      console.log(folder + '.zip');
      console.log(res.data + '.zip');
      FileDownload(res.data, folder + '.zip');
      setMessage(false);
      fetchScorms();
    });
  }

  const callMoodleFunc = (rid, isweb) => (e) => {
    var headers = { ...Utils.apiHeaders(), "responseType": "blob" };
    setMessage(['info', ['Please wait, calling to moodle...']]);
    setMessage(['info', ['Please wait, calling to moodle...']]);
    var api = '';
    var zipContent = '';
    if (isweb === '1') {
      api = Utils.apiUrl('Web/download?id=' + rid);
    } else {
      api = Utils.apiUrl('Scorm/getScormZipFile?id=' + rid);
    }
    axios.get(api, headers).then((res) => {
      zipContent = res.data;
      //FileDownload(res.data, 'abc.zip');
      setMessage(false);
      fetchScorms();
      var fName = Utils.getFunctionNameLF();
      console.log("Function Name is  : " + fName);
      console.log("on 2 jan 23 : ");
      try {
        if (zipContent !== '') {
          window.parent.postMessage({
            'func': fName,
            'message': zipContent
          }, "*");
        }
      } catch (err) {
        console.log(err.message);
      }
    });


    setMessage(false);
    fetchScorms();
  }

  const onDelete = (rid) => (e) => {

    const ans = window.confirm("Do you want to delete this record?");
    if (ans) {
      axios.delete(
        Utils.apiUrl(`Scorm/deletescorm/:${rid}`),
        Utils.apiHeaders()
      )
        .then(res => {
          if (res.data.success) fetchScorms();
        })
        .catch(err => {
          console.log(err)
        });
    }
  }

  const onSort = (ck) => (e) => {
    const tmp = { ...filter };
    if (tmp.sortby === ck) {
      tmp.sortdir = tmp.sortdir === 'asc' ? 'desc' : 'asc';
    } else {
      tmp.sortby = ck;
      tmp.sortdir = 'desc';
    }
    setFilter({ ...tmp });
  }

  const handleBack = () => {
    window.location.href = `${process.env.PUBLIC_URL}/builder`;
  }

  const actionIcon = (e) => {

  }

  const renderListing = () => {
    const cols = {
      'id': 'Sl.',
      'name': 'Name',
      'slides': 'Slides',
      'created_at': 'Created On',
      'publishes': 'Downloads',
      'is_web': 'Type',
    };
    return <>
      {renderPaging()}
      <Table striped>
        <tr>
          {Object.keys(cols).map(ck => <th key={ck} className={`text-${ck == 'id' || ck == 'name' ? 'left' : 'center'}`}>
            <span className="clickable text-info" onClick={onSort(ck)}>{cols[ck]}</span>
            {filter.sortby === ck && <i className={`ml-1 sort-arrow fa fa-arrow-${filter.sortdir == 'asc' ? 'up' : 'down'} text-dark`} />}
          </th>)}
          <th className="text-center">Action</th>
        </tr>
        {data.map((rec, idx) => <tr key={rec.id}>
          <td>{filter.offset + idx + 1}</td>
          <td>{(rec.name).length > 40 ? rec.name.substr(0, 40) : rec.name}</td>
          <td className="text-center">{rec.slides}</td>
          <td className="text-center">{moment(rec.created_at).format("DD MMM YYYY hh:mm a")}</td>
          <td className="text-center"><Badge variant="dark">{rec.publishes}</Badge></td>
          <td className="text-center" title={parseInt(rec.is_web) === 0 ? 'Scorm Course' : 'Web Course'}>{rec.is_web == 0 ? <i className="fa fa-file-archive-o" aria-hidden="true"></i> : <i className="fa fa-globe" aria-hidden="true"></i>}</td>
          <td className="text-center actions">
            <span className="edit clickable" onClick={onEdit(rec)} onMouseOver={(e) => { actionIcon(e) }} title="Edit Package" />
            <span className="clone clickable" title="Clone and Edit Package" onClick={onClone(rec.id, rec.is_web)} />
            <span className="download clickable" title="Download Package" onClick={onDownload(rec.id, rec.name, rec.is_web)} />
            <span className="delete clickable" title="Delete Package" onClick={onDelete(rec.id)} />
            {Utils.getFromLF() !== '' && Utils.getFromLF() === 'moodle' && <span className="clone clickable" title="send Link to Moodle" onClick={callMoodleFunc(rec.id, rec.is_web)} />}
          </td>
        </tr>)}
      </Table>
      {renderPaging()}
    </>
  }

  const renderPaging = () => {
    return <div className="text-right pager">
      {filter.offset - filter.limit >= 0 && <span className="fa fa-chevron-left mx-2 clickable" title="Previous page" onClick={() => setFilter({ ...filter, offset: filter.offset - filter.limit })} />}
      {filter.offset - filter.limit < 0 && <span className="fa fa-chevron-left text-disabled" />}
      {filter.offset + filter.limit < total && <span className="fa fa-chevron-right mx-2 clickable" title="Next page" onClick={() => setFilter({ ...filter, offset: filter.offset + filter.limit })} />}
      {filter.offset + filter.limit > total && <span className="fa fa-chevron-right text-disabled" />}
    </div>
  }

  return <Container className="scromlist">
    <div className="mb-3"><span className="clickable" title="Back to Previous Screen" onClick={handleBack}><img src={`${process.env.PUBLIC_URL}/images/back_arrow.png`} alt="Back" /> Back</span></div>
    <div className="heading mb-4">My SVASU Packages&nbsp;
      <span onClick={handleAdd} className="clickable" title="Build Your SVASU"><i className="fa fa-plus" /></span>
    </div>

    <Card className="card-box w-100">
      <Card.Body className="p-4">
        {showDraft && <div className="list-draft">
          <span className="deletedraft" style={{ fontSize: "16px" }}><strong>Draft :</strong> <span className="clickable" onClick={getDraft} >Continue/</span>
            <span className="clickable" onClick={delDraft} >Discard</span>
          </span>
        </div>}
        <ol className="instructions">
          <li><span>Modify any course by clicking the <i className="edit"></i><strong>Edit Package</strong>. </span></li>
          <li><span>Click the <i className="clone"></i><strong> Clone & Edit Package </strong> to clone and edit the package. </span> </li>
          <li><span>Click the <i className="download"></i><strong>Download Package</strong> to download any package.</span></li>
          {(pkgInfo !== false && parseInt(pkgInfo.id) !== 0) &&
            <li><span>Your <strong>{pkgInfo.package} </strong>
              {parseInt(pkgInfo.cloud) ? ' cloud package with around ' + (Math.ceil((pkgInfo.size) / 1024) * 100) / 100 + ' GB of space ' : ' non-cloud package '}
              is valid until <strong>{moment(pkgInfo.due_date).format("Do MMMM YYYY")}</strong>.</span></li>}
        </ol>

        {loading && <div className="text-center p-2 m-2"><Alert> {loading}<br /><ProgressBar className="mt-2" animated variant="primary" now={100} /></Alert></div>}
        {!loading && total > 0 && renderListing()}
        {(!loading && parseInt(total) == 0 && !(_.isUndefined(pkgInfo)) && (parseInt(pkgInfo.id) !== 0) && parseInt(pkgInfo.cloud) === 1) &&
          <div className={`text-center p-2 m-2 ${parseInt(pkgInfo.cloud) === 1 ? '' : 'd-none'}`} ><Alert variant="warning">No Records found</Alert></div>}
        {(!loading && parseInt(pkgInfo.cloud) !== 1 && parseInt(pkgInfo.id) !== 0) && <div className="text-center">
          <p>Here you will get a list of courses saved on SVASU Cloud. </p>
          <div>To create your {pkgInfo !== false ? 'new' : 'free'} course, <span className="clickable" onClick={handleAdd}><strong>Click Here.</strong></span></div><br />
          <div>To {pkgInfo !== false ? 'upgrade' : 'buy'} your plan, <span className="clickable" onClick={handleBuy}>
            <strong>Click Here.</strong></span></div>
        </div>}
        {(!loading && parseInt(pkgInfo.id) === 0) && <div className="text-center p-2 m-2">
          <Alert variant="warning">
            <h3 className="text-dark">Want to continue with the SVASU journey?</h3>
            <Alert><p>You have used the <strong>free-trial </strong>package.</p>
              <p>Here you will get a list of your published packages stored on svasu.cloud.</p>
              <p>If you want to continue with us, please explore and buy SVASU's packages as per your requirements.</p>
            </Alert>
            <a className="btn btn-primary active px-4 mb-4" href={`${process.env.REACT_APP_URL}#buy-now`}>Buy Now</a>
          </Alert>
        </div>
        }

        {message && <MessageModal type={message[0]} dwn={true} message={message[1]} onHide={() => { setMessage(false); }} />}
        {total > 0 && <div> Total: {total} </div>}
      </Card.Body>
    </Card>
  </Container>;
}

export default UserScormList;